
export default {
  props: {
    theme: {
      type: String,
    },
  },
  data() {
    return {
      navbar: false,
      buttons: [
        {
          external: false,
          fr: {
            url: "/blog-innovation-product-design-developpement-web/",
            content: "Tous les articles",
          },
        },
        {
          external: false,
          fr: {
            url: "/blog-innovation-product-design-developpement-web/trends/",
            content: "Trends",
          },
        },
        {
          external: false,
          fr: {
            url: "/blog-innovation-product-design-developpement-web/whitebook/",
            content: "Livre blanc",
          },
        },
        {
          external: false,
          fr: {
            url: "/blog-innovation-product-design-developpement-web/work-culture/",
            content: "Work culture",
          },
        },
      ],

      categories: {
        fr: {
          content: "Catégories +",
          url: "/blog-innovation-product-design-developpement-web/business/",
        },
      },
    };
  },
};
